export default "__VITE_ASSET__CXvuvhsd__"